import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import MembershipCustomTextContent from '../../component/MembershipCustomTextContent/MembershipCustomTextContent'
import { Helmet } from 'react-helmet'

const listData = [
     {
        img:"/images/creatives/aging-wellness-text-1.png",
        title:"Why it matters",
        para:"Healthy aging doesn’t happen by chance; it happens by design."
    },
     {
        img:"/images/creatives/aging-wellness-text-1.png",
        title:"Who it’s for",
        para:"Adults 40+ interested in preventative strategies and lifelong vitality."
    },
     {
        img:"/images/creatives/aging-wellness-text-1.png",
        title:"How it works",
        para:"Comprehensive assessment, lab testing, and a tailored care roadmap with periodic reviews."
    },
]


const cardList = [
  {
    link:"/audiology",
        img:"/images/creatives/service-main-2.webp",
    name:" Audiology",
    rank:"",
    para:'Advanced hearing diagnostics to prevent and manage hearing concerns at any age.'
  },
  {
    link:"/naturopathic-medicine",
    img:"/images/creatives/service-main-9.webp",
    name:"Naturopathic Medicine",
    rank:"",
    para:'An integrative approach combining clinical science and natural therapies to optimize health.'
  },
  // {
  //    link:"/women",
  //       img:"/images/creatives/service-main-11.webp",
  //   name:" Pelvic Floor Therapy – Women ",
  //   rank:"",
  //   para:'Specialized rehabilitation to restore pelvic health after childbirth, surgery or menopause.'
  // },
]

const boostCardData = [
    "Reduce risk of age-related disease",
    "Maintain strength, balance, and independence",
    "Enhance mental and cognitive resilience",
    "Feel empowered through education and proactive planning",

]

function GHAP() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Aging & Wellness Clinic (GHAP) | The Toronto Clinic
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/aging-wellness-clinic"
        />
        <meta
          name="description"
          content="Experience proactive, personalized healthcare for adults 40+. GHAP helps reduce disease risk, build resilience, and support lifelong vitality."
        ></meta>
        
      </Helmet>
         <Header/>
        <HomeHero
            heading='Aging & Wellness Clinic (GHAP)'
            content='A proactive, personalized medical program for graceful, healthy aging.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/ghaphero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
            calendlyType={11}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="Our GHAP (Global Healthy Aging Program) provides a holistic approach to longevity, prevention, and life-quality enhancement. Combining advanced screening, lifestyle medicine, and targeted therapies, we help you stay healthier and stronger for longer."
            bgImg="/images/creatives/service-main-7.webp"
          />

            <MembershipCustomTextContent
            listData={listData}
            shiftRow={true}
            nonSwitchingImg={true}
          />

        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />

        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph=""
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default GHAP